module.exports = __webpack_public_path__ + "static/media/file-shield-alt.51bf2492.svg";